import { action, observable, makeObservable } from 'mobx';
import {
  contentLoaders,
  SuccessResponse,
  X5Lesson,
  X5LessonType,
  X5LessonUpdateModel
} from '../../../../domain';
import {
  Control,
  HttpPromiseState,
  SaveStateHolder,
  StringControl,
  validators
} from '../../../../lib/helpers';

export class EditLessonStore implements SaveStateHolder {
  lessonType: Control<X5LessonType | null>;

  name: StringControl;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly lesson: X5Lesson) {
    makeObservable(this);
    this.lessonType = new Control<X5LessonType | null>(
      'lesson type', lesson.LessonType, validators.required)
    this.name = new StringControl('name', lesson.Name, validators.required);
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.lessonType.markTouched();
    this.name.markTouched();
    if (this.name.invalid || this.lessonType.invalid)
      return;
    const model: X5LessonUpdateModel = {
      UnitId: this.lesson.UnitId,
      Index: this.lesson.Index,
      LessonType: this.lessonType.value!,
      Name: this.name.value
    };
    this.save = contentLoaders.x5lesson.update(this.lesson.Id, model);
  }
}
